module.exports = __webpack_public_path__ + "static/img/z1.8c5f0792.png";